import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';

import backgroundStartup from '../../assets/background-startup.jpg';
import graph from '../../assets/graph.png';

export const Background = styled.div`
  position: relative;
  overflow-x: hidden;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-color: ${BaSeTheme.colors.defaultColors.black};
  background-repeat: no-repeat;
  ${({ module }) =>
    Number(module) === 1 &&
    css`
      background-position: center top 250px;
      background-image: url(${graph});
    `}

  ${({ module }) =>
    Number(module) === 2 &&
    css`
      background-image: url(${backgroundStartup});
    `} /* &::before {
    position: fixed;
    content: '';
    width: 100vw;
    height: 100vh;
    display: block;
    top: 0;
    right: 0;
    background: radial-gradient(
      circle at top right,
      #175e8b -30vh,
      transparent 40vw
    );
  } */
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 0 30px;

  img {
    width: 350px;
    height: 683px;
  }
`;

export const Aside = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 40%;
  padding-left: 100px;

  img {
    &:first-child {
      width: 160px;
      height: 210px;
    }
    width: 500px;
    height: 42px;
  }
`;

export const AlignText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
